import { atom } from "jotai";

/**
 * Stores a string that represents the memory level. Things like `low`, `mid`, `high`, `full`.
 */
export const memoryStatusAtom = atom<string | null>(null);
